import axios from '../../axios'

// 拉取问题投诉模版接口
export function getTempletList(params) {
  return axios.get('/complaint/getTempletList', params)
}

// 提交投诉
export function subComplaint(params) {
  return axios.post('/complaint/subComplaint', params)
}

// 验证是否包含敏感关键词
export function checkSensitiveWords(params, config) {
  return axios.get('/sensitivewords/checkSensitiveWords', params, config)
}
